/* Consentmo tekent zijn banner in een shadow DOM, dus de thema-CSS komt er niet bij,
   en zijn eigen Custom CSS zit alleen in het Plus-plan. Op mobiel stapelde hij drie
   knoppen onder elkaar en bedekte zo ~45% van het scherm, ook de afrekenknop in de tas.
   Dit script hangt één stijlblok in die shadow DOM: knoppen naast elkaar, kleinere tekst.
   Accept all en Reject all blijven even groot (ICO: gelijke nadruk). */
(function () {
  /* Selectors bewust dubbel: Consentmo zet zelf !important met zwaardere selectors. */
  var W = ':host .csm-cmp-bar .csm-cmp-body';
  var CSS = '@media (max-width: 767px){' +
    W + '.csm-cmp-body{padding:12px 14px !important}' +
    W + ' .cc-message.cc-message{font-size:13px !important;line-height:1.4 !important;margin:0 0 10px !important}' +
    W + ' .cc-compliance.cc-compliance.cc-highlight{flex-direction:row-reverse !important;flex-wrap:nowrap !important;gap:6px !important}' +
    W + ' .cc-compliance.cc-compliance .cc-btn.cc-btn{flex:1 1 0 !important;width:auto !important;min-width:0 !important;margin:0 !important;padding:6px 4px !important;font-size:13px !important;white-space:nowrap !important}' +
    '}';
  function zetStijl(sr) {
    if (sr.querySelector('style[data-draycott]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-draycott', '');
    s.textContent = CSS;
    sr.appendChild(s);
  }
  function zet() {
    var h = document.querySelector('csm-cookie-consent');
    if (!h || !h.shadowRoot) return false;
    var sr = h.shadowRoot;
    zetStijl(sr);
    /* Consentmo vervangt de inhoud van zijn shadow DOM na het tekenen; een los
       toegevoegd stijlblok verdwijnt dan. Daarom kijken we daar blijvend mee. */
    new MutationObserver(function () { zetStijl(sr); }).observe(sr, { childList: true });
    return true;
  }
  if (zet()) return;
  /* De banner komt pas na het laden van de app; daarna stoppen we met kijken. */
  var mo = new MutationObserver(function () { if (zet()) mo.disconnect(); });
  mo.observe(document, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 20000);
})();
